import { TitleAndTab } from "/react4xp/parts/title-and-tab/title-and-tab";

export default (props) => <TitleAndTab {...props} />